import React, { useState, Fragment, useEffect } from 'react';
import styles from './Applications.module.css';
import { Row, Col, Card, Tooltip, Space, Spin, Input, Button, Table, Modal, Tag, Typography } from 'antd';
import { CloudDownloadOutlined, OrderedListOutlined, InfoCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { fetchUserVal, fetchJsData } from '../../../../api';
import { CSVLink } from 'react-csv';
import Highlighter from 'react-highlight-words';
const { Search } = Input;
const { Text } = Typography;

const fetchUserSearch = async (rel, type) => {
    const data = await fetchUserVal('fetConAppsUc', {
        firstVal: rel,
        secondVal: rel,
        thirdVal: rel,
    });
    return data;
};

export const FetchUcTabSearch = (props) => {
    const [load, setLoad] = useState(props.load);
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(true);
    const [app, setApp] = useState('');
    const [trig, setTrig] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const ColUc = [
        {
            title: () => {
                return (
                    <>
                        Application name{' '}
                        {loading ? (
                            <div>
                                <Spin size="small" />
                            </div>
                        ) : (
                            <Tag color="processing">{filteredData.length}</Tag>
                        )}
                    </>
                );
            },
            dataIndex: 'current_name',
            key: 'current_name',
            fixed: 'left',
            width: '40%',
            sorter: (a, b) => (a.current_name ? a.current_name.localeCompare(b.current_name) : 1),
            render: (text, record) => (
                <Space size="middle">
                    <Tooltip title={record.application_name}>
                        <a
                            onClick={() => {
                                setApp(record.current_name);
                                setOpenModal(true);
                                setTrig(!trig);
                            }}
                        >
                            {record.current_name}
                        </a>
                    </Tooltip>
                </Space>
            ),
        },
        {
            title: 'Category',
            dataIndex: 'category_name',
            key: 'category_name',
            sorter: (a, b) => (a.category_name ? a.category_name.localeCompare(b.category_name) : 1),
            fixed: 'left',
            width: '26%',
        },
        {
            title: 'DLP',
            dataIndex: 'dlp',
            key: 'dlp',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.dlp - b.dlp,
            fixed: 'left',
            width: '17%',
        },
        {
            title: 'TSS',
            dataIndex: 'tss',
            key: 'tss',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.tss - b.tss,
            fixed: 'left',
            width: '17%',
        },
    ];

    useEffect(() => {
        setLoading(true);
        const crawl = (user, allValues) => {
            if (!allValues) allValues = [];
            for (var key in user) {
                if (typeof user[key] === 'object') crawl(user[key], allValues);
                else allValues.push(user[key] + ' ');
            }
            return allValues;
        };
        const fetchData = async () => {
            const { data: users } = await fetchUserSearch(props.usrRel, props.type);
            setOrigData(users);
            setFilteredData(users);
            const searchInd = users.map((user) => {
                const allValues = crawl(user);
                return { allValues: allValues.toString() };
            });
            setSearchIndex(searchInd);
            if (users) setLoading(false);
        };
        fetchData();
    }, [props.submit]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.submit]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col className="gutter-row" span={1}></Col>
                    <Col span={22}>
                        <Card
                            title={'Release - ' + props.usrRel.split('snapshot_v')[1].split('_')[0]}
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                            enterButton
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col className="gutter-row" span={2}>
                                        {' '}
                                        <div>
                                            {loading ? (
                                                <div>
                                                    <Spin size="small" />
                                                </div>
                                            ) : (
                                                <Tooltip
                                                    placement="topRight"
                                                    title="Download CASB Universal Report"
                                                    arrowPointAtCenter
                                                    // color={"#CCD1D1"}
                                                    // key={"#2db7f5"}
                                                >
                                                    <CSVLink
                                                        filename={'CASB Universal Connector Report.csv'}
                                                        data={filteredData}
                                                        className="btn btn-primary"
                                                    >
                                                        <CloudDownloadOutlined style={{ fontSize: '29px' }} />
                                                    </CSVLink>
                                                </Tooltip>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="application_id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={ColUc}
                                    loading={loading}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                    }}
                                />
                            </Fragment>
                            <Fragment>
                                <OpenMod
                                    usrRel={props.usrRel}
                                    rel={props.rel}
                                    type={props.type}
                                    app={app}
                                    openModal={openModal}
                                    trig={trig}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

const OpenMod = (props) => {
    const [app, setApp] = useState(props.app);
    const [load, setLoad] = useState(true);
    const [usrRel, setUsrRel] = useState(props.usrRel);
    const [rel, setRel] = useState(props.rel);
    const [modData, setModData] = useState({
        conActName: 'conAct',
        conAct: '',
        conActDom: '',
    });
    const [comp, setComp] = useState(false);
    const [showAct1, setShowAct1] = useState(false);
    const [showAct2, setShowAct2] = useState(false);
    const [showDom1, setShowDom1] = useState(false);
    const [showDom2, setShowDom2] = useState(false);
    const [show, setShow] = useState(false);
    const openModal = () => setShow(props.openModal);
    const closeModal = () => {
        setShow(false);
        setComp(false);
    };
    const prevRel = rel - 1;
    const ppRel = rel - 2;
    const [compDomData, setCompDomData] = useState([
        {
            release: '',
            actName: '',
            domain: '',
        },
    ]);

    // initial effect
    useEffect(() => {
        setApp(props.app);
        if (props.openModal === true) {
            openModal();
            fetchData();
            setCompDomData([
                {
                    release: '',
                    actName: '',
                    domain: '',
                },
            ]);
        }
    }, [props.app, props.trig]);

    // Compare effect
    useEffect(() => {
        if (!compDomData[0]['release']) {
            fetchCompData();
        }
    }, [comp]);

    const fetchData = async () => {
        setLoad(true);
        setUsrRel(props.usrRel);
        const fetConActivity = await fetchUserVal('fetConActivity', {
            firstVal: props.usrRel,
            secondVal: props.usrRel,
            thirdVal: props.usrRel,
            fourthVal: props.app,
        });

        const fetConAppAct = await fetchJsData({
            type: 'fetch',
            qry: 'fetConAppActDom',
            firstVal: props.app,
            secondVal: props.usrRel,
            thirdVal: props.usrRel,
            fourthVal: props.usrRel,
            fifthVal: props.usrRel,
            sixthVal: props.usrRel,
        });

        // setRel("snapshot_" + relVersion["version"]);
        setModData({
            conActName: fetConActivity['data'][0]['category_name'],
            conAct: fetConAppAct['data'][1][0]['activityV1'],
            conActDom: fetConAppAct['data'][1][0]['domV1'],
        });
        setLoad(false);
    };

    const fetchCompData = async () => {
        setLoad(true);
        setUsrRel(props.usrRel);
        if (show) {
            const domData = await fetchJsData({
                type: 'fetch',
                qry: 'fetConDoms',
                preProcFunc: 'appDomInfo',
                preProcess: true,
                firstVal: props.app,
                secondVal: 'snapshot_v' + ppRel + '_0_0',
                thirdVal: 'snapshot_v' + ppRel + '_0_0',
                fourthVal: 'snapshot_v' + prevRel + '_0_0',
                fifthVal: 'snapshot_v' + prevRel + '_0_0',
                sixthVal: 'snapshot_v' + rel + '_0_0',
                seventhVal: 'snapshot_v' + rel + '_0_0',
            });

            // setCompData(actData["data"]);
            setCompDomData(domData['data']);
        }
        setLoad(false);
    };

    const compare = async () => {
        setShowAct1(false);
        setShowAct2(false);
        setShowDom1(false);
        setShowDom2(false);
        setComp(!comp);
    };

    const dataAct = [
        {
            id: 1,
            release: 'Release ' + ppRel,
            actName: 'Download, FormPost, Login Attempt, Login Failed, Login Successful, Logout, Upload.',
        },
        {
            id: 2,
            release: 'Release ' + prevRel,
            actName: 'Download, FormPost, Login Attempt, Login Failed, Login Successful, Logout, Upload.',
        },
        {
            id: 3,
            release: 'Release ' + rel,
            actName: 'Download, FormPost, Login Attempt, Login Failed, Login Successful, Logout, Upload.',
        },
    ];

    return (
        <Modal
            // title={app + " > " + modData["conActName"]}
            title={
                load ? (
                    <div>
                        <Spin size="small" />
                    </div>
                ) : (
                    <Row gutter={16}>
                        <Col className="gutter-row" span={19}>
                            <Text keyboard>
                                <>{app + ' > ' + modData['conActName']}</>
                            </Text>
                        </Col>

                        <Col className="gutter-row" span={2}>
                            <Space size="small" align="end">
                                <Button type="dashed" shape="round" onClick={compare} style={{ backgroundColor: '#f0f5ff' }} size="small">
                                    compare
                                </Button>
                                {comp ? (
                                    <Tooltip
                                        title={
                                            <div
                                                style={{
                                                    fontSize: '9px',
                                                    fontFamily: 'Gill, Helvetica, sans-serif',
                                                }}
                                            >
                                                <ul>
                                                    <li>
                                                        <p>
                                                            <Text>No Change</Text>: indicates same as previous release
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            <Text delete type="danger">
                                                                Red Text
                                                            </Text>
                                                            : indicates removed in this release
                                                        </p>
                                                        {/* <span style={{ color: "red" }}>Red text</span> */}
                                                    </li>
                                                    <li>
                                                        <p>
                                                            <Text type="success">Green Text</Text>: indicates added in this release
                                                        </p>
                                                    </li>
                                                </ul>
                                            </div>
                                        }
                                        color="#425162"
                                    >
                                        <InfoCircleOutlined />
                                    </Tooltip>
                                ) : (
                                    <Tooltip
                                        title={
                                            <div
                                                style={{
                                                    fontSize: '9px',
                                                    fontFamily: 'Gill, Helvetica, sans-serif',
                                                }}
                                            >
                                                <p>P1 activities are marked in bold</p>
                                            </div>
                                        }
                                        color="#425162"
                                    >
                                        <InfoCircleOutlined />
                                    </Tooltip>
                                )}
                            </Space>
                        </Col>
                    </Row>
                )
            }
            visible={show}
            onOk={closeModal}
            confirmLoading={load}
            onCancel={closeModal}
            width={'50%'}
        >
            <Card className={styles.chart} size="small" headStyle={{ border: 2 }} bordered={true} loading={load}>
                {comp ? (
                    <>
                        <Card
                            className={styles.chart}
                            title={<Text keyboard> Activity </Text>}
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                            bordered={true}
                            loading={load}
                        >
                            {load ? (
                                <div>
                                    <Spin size="small" />
                                </div>
                            ) : (
                                <>
                                    <Table
                                        rowkey="appAct_id"
                                        size="small"
                                        bordered
                                        className="test"
                                        pagination={false}
                                        dataSource={dataAct}
                                        columns={[
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Release </div>;
                                                },
                                                dataIndex: 'release',
                                                key: 'release',
                                                fixed: 'left',
                                                width: '10%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Activity </div>;
                                                },
                                                dataIndex: 'actName',
                                                key: 'actName',
                                                fixed: 'left',
                                                responsive: ['sm'],
                                                width: '90%',
                                                render: (text, row) => (
                                                    <>
                                                        {row.id == 1 ? (
                                                            <span style={{ fontSize: '11px' }}>{text}</span>
                                                        ) : row.id == 2 ? (
                                                            <div
                                                                onClick={() => {
                                                                    setShowAct1(!showAct1);
                                                                }}
                                                                style={{ fontSize: '11px' }}
                                                            >
                                                                {!showAct1 ? <a>No Change</a> : text}
                                                            </div>
                                                        ) : (
                                                            <div
                                                                onClick={() => {
                                                                    setShowAct2(!showAct2);
                                                                }}
                                                                style={{ fontSize: '11px' }}
                                                            >
                                                                {!showAct2 ? <a>No Change</a> : text}
                                                            </div>
                                                        )}
                                                    </>
                                                ),
                                            },
                                        ]}
                                        loading={load}
                                    />
                                </>
                            )}
                        </Card>

                        <Card
                            className={styles.chart}
                            title={<Text keyboard> Domain </Text>}
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                            bordered={true}
                            loading={load}
                        >
                            {load ? (
                                <div>
                                    <Spin size="small" />
                                </div>
                            ) : (
                                <>
                                    <Table
                                        rowKey="appDom_id"
                                        size="small"
                                        bordered
                                        pagination={false}
                                        dataSource={compDomData}
                                        columns={[
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Release </div>;
                                                },
                                                dataIndex: 'release',
                                                key: 'release',
                                                fixed: 'left',
                                                width: '10%',
                                                render: (text) => <span style={{ fontSize: '11px' }}>{text}</span>,
                                            },
                                            {
                                                title: () => {
                                                    return <div style={{ fontSize: '12px' }}>Domain </div>;
                                                },
                                                dataIndex: 'domName',
                                                key: 'domName',
                                                fixed: 'left',
                                                responsive: ['sm'],
                                                width: '90%',
                                                render: (text, row) => (
                                                    <>
                                                        {row.id == 1 ? (
                                                            text ? (
                                                                <span style={{ fontSize: '11px' }}>{text.replaceAll(',', ', ')}</span>
                                                            ) : (
                                                                text
                                                            )
                                                        ) : row.id == 2 ? (
                                                            <div
                                                                onClick={() => {
                                                                    setShowDom1(!showDom1);
                                                                }}
                                                                style={{ fontSize: '11px' }}
                                                            >
                                                                {!showDom1 ? (
                                                                    row.domComp == 'No Change' ? (
                                                                        <a>{row.domComp}</a>
                                                                    ) : row.domAdded.length != 0 && row.domRemoved.length != 0 ? (
                                                                        <>
                                                                            <Text type="success">
                                                                                {row.domAdded.toString().includes(',')
                                                                                    ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                    : row.domAdded.toString()}{' '}
                                                                            </Text>{' '}
                                                                            <Text delete type="danger">
                                                                                {row.domRemoved.toString().includes(',')
                                                                                    ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                    : row.domRemoved.toString()}{' '}
                                                                            </Text>
                                                                        </>
                                                                    ) : row.domAdded.length != 0 ? (
                                                                        <Text type="success">
                                                                            {row.domAdded.toString().includes(',')
                                                                                ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                : row.domAdded.toString()}{' '}
                                                                        </Text>
                                                                    ) : (
                                                                        <Text delete type="danger">
                                                                            {row.domRemoved.toString().includes(',')
                                                                                ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                : row.domRemoved.toString()}{' '}
                                                                        </Text>
                                                                    )
                                                                ) : text ? (
                                                                    text.replaceAll(',', ', ')
                                                                ) : (
                                                                    text
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <div
                                                                onClick={() => {
                                                                    setShowDom2(!showDom2);
                                                                }}
                                                                style={{ fontSize: '11px' }}
                                                            >
                                                                {!showDom2 ? (
                                                                    row.domComp == 'No Change' ? (
                                                                        <a>{row.domComp}</a>
                                                                    ) : row.domAdded.length != 0 && row.domRemoved.length != 0 ? (
                                                                        <>
                                                                            <Text type="success">
                                                                                {row.domAdded.toString().includes(',')
                                                                                    ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                    : row.domAdded.toString()}{' '}
                                                                            </Text>{' '}
                                                                            <Text delete type="danger">
                                                                                {row.domRemoved.toString().includes(',')
                                                                                    ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                    : row.domRemoved.toString()}{' '}
                                                                            </Text>
                                                                        </>
                                                                    ) : row.domAdded.length != 0 ? (
                                                                        <Text type="success">
                                                                            {row.domAdded.toString().includes(',')
                                                                                ? row.domAdded.toString().replaceAll(',', ', ')
                                                                                : row.domAdded.toString()}{' '}
                                                                        </Text>
                                                                    ) : (
                                                                        <Text delete type="danger">
                                                                            {row.domRemoved.toString().includes(',')
                                                                                ? row.domRemoved.toString().replaceAll(',', ', ')
                                                                                : row.domRemoved.toString()}{' '}
                                                                        </Text>
                                                                    )
                                                                ) : text ? (
                                                                    text.replaceAll(',', ', ')
                                                                ) : (
                                                                    text
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                ),
                                            },
                                        ]}
                                        loading={load}
                                    />
                                </>
                            )}
                        </Card>
                    </>
                ) : (
                    <>
                        <Card
                            className={styles.chart}
                            title={<Text keyboard> Activity </Text>}
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                            bordered={true}
                            loading={load}
                        >
                            <div style={{ fontSize: '12px' }}>
                                <Highlighter
                                    highlightClassName="YourHighlightClass"
                                    searchWords={['Download', 'Login Successful', 'Upload']}
                                    highlightStyle={{
                                        backgroundColor: 'white',
                                        fontFamily: 'Arial Rounded MT Bold',
                                    }}
                                    autoEscape={true}
                                    caseSensitive={true}
                                    textToHighlight="Download, FormPost, Login Attempt, Login Failed, Login Successful,
                  Logout, Upload. These are possible activities detected by
                  Universal Connector."
                                />
                            </div>
                        </Card>

                        <Card
                            className={styles.chart}
                            title={<Text keyboard> Domain </Text>}
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 1 }}
                            bordered={true}
                            loading={load}
                        >
                            <Text style={{ fontSize: '12px' }}>
                                {modData['conActDom'] ? modData['conActDom'].replaceAll(',', ', ') : modData['conActDom']}
                            </Text>
                        </Card>
                    </>
                )}
            </Card>
        </Modal>
    );
};
